package com.gloopgo.game.di

import com.gloopgo.game.domain.PelletSpawnCalculator
import com.gloopgo.game.engine.GameEngine
import com.gloopgo.game.moderation.BlockedPlayersStore
import com.gloopgo.game.moderation.createBlockedPlayersStore
import com.gloopgo.game.network.FirebaseMultiplayerRepository
import com.gloopgo.game.network.MultiplayerRepository
import com.gloopgo.game.repository.LoggerRepository
import com.gloopgo.game.repository.LoggerRepositoryImpl
import com.gloopgo.game.viewmodel.AuthViewModel
import com.gloopgo.game.viewmodel.ConnectingViewModel
import com.gloopgo.game.viewmodel.GameViewModel
import com.gloopgo.game.viewmodel.LeaderboardViewModel
import com.gloopgo.game.viewmodel.MenuViewModel
import org.koin.core.module.dsl.viewModelOf
import org.koin.dsl.module

val appModule = module {
    single<LoggerRepository> { LoggerRepositoryImpl() }
    single<MultiplayerRepository> { FirebaseMultiplayerRepository(logger = get()) }
    single<BlockedPlayersStore> { createBlockedPlayersStore() }
    single { PelletSpawnCalculator() }
    single<com.gloopgo.game.audio.SoundManager> { com.gloopgo.game.audio.getSoundManager() }
    factory { GameEngine() }

    viewModelOf(::AuthViewModel)
    viewModelOf(::MenuViewModel)
    viewModelOf(::ConnectingViewModel)
    viewModelOf(::GameViewModel)
    viewModelOf(::LeaderboardViewModel)
}
